import $ from 'jquery';

$( '.modal' ).on( 'shown.bs.modal', () => {
  $(this).find( '[autofocus]' ).focus();
});
